import { DiscordIcon, EmailIcon, GithubIcon, LinkDinIcon, TelegramIcon, TwitterIcon } from "@images/svg";
import React, { JSX } from "react";

type Route = {
    id: number;
    name: string;
    path: string;
};

type Social = {
    id: number;
    name: string;
    link: string;
    img: JSX.Element;
};

type SidebarItem = {
    id: number;
    name: string;
    icon: JSX.Element;
    link: string;
};

type Header = {
    routes: Route[];
    logo: string;
    logoTitle: string;
};

type Footer = {
    socials: Social[];
    socialsTitle: string;
    description: string;
    link: string;
    copyRight: string;
    logo: string;
    logoTitle: string;
    refText: string;
};

type Layout = {
    header: Header;
    footer: Footer;
    sidebar: SidebarItem[];
};

export const layout: Layout = {
    header: {
        routes: [
            {
                id: 1,
                name: "home",
                path: "/",
            }, {
                id: 2,
                name: "about-me",
                path: "/about",
            },
            {
                id: 3,
                name: "portfolio",
                path: "/portfolio",
            },
            {
                id: 4,
                name: "experience",
                path: "/experience",
            },
            {
                id: 5,
                name: "certification",
                path: "/certification",

            },
            {
                id: 6,
                name: "education",
                path: "/education",
            },
            {
                id: 7,
                name: "contact",
                path: "/contact",
            }
        ],
        logo: require('../assets/images/logo.png'),
        logoTitle: "Abdul Kader",
    },
    footer: {
        socials: [
            {
                id: 1,
                name: 'github',
                link: "https://github.com/abdulkadershohan",
                img: React.createElement(GithubIcon)
            },
            {
                id: 2,
                name: 'linkedin',
                link: "https://www.linkedin.com/in/abdulkadershohan/",
                img: React.createElement(LinkDinIcon)
            },
            {
                id: 3,
                name: 'telegram',
                link: "https://t.me/Abdulkadershohan",
                img: React.createElement(TelegramIcon)
            },
            {
                id: 4,
                name: 'twitter',
                link: "https://twitter.com/dev_shohan",
                img: React.createElement(TwitterIcon)
            },
            {
                id: 5,
                name: 'discord',
                link: "https://discord.com/users/522431317447802900",
                img: React.createElement(DiscordIcon)
            }
        ],
        socialsTitle: "Social Media",
        description: `Software Engineer & Frontend Specialist based in Bangladesh`,
        link: 'https://dev-shohan.netlify.app/',
        copyRight: 'Abdul Kader Shohan. All rights reserved.',
        logo: require('../assets/images/logo.png'),
        logoTitle: 'Abdul Kader',
        refText: 'Special Thanks to Elias Dev for sharing this UI/UX design with Figma Community',

    },
    sidebar: [
        {
            name: 'discord',
            icon: React.createElement(DiscordIcon),
            link: 'https://discord.com/users/522431317447802900',
            id: 1
        },
        {
            name: 'github',
            icon: React.createElement(GithubIcon),
            link: "https://github.com/abdulkadershohan",
            id: 2
        },
        {
            name: 'email',
            icon: React.createElement(EmailIcon),
            link: "mailto:abdulkadirshohan@gmail.com",
            id: 3
        }

    ]
}
